import { render } from "./LoginPage.vue?vue&type=template&id=260194ca&scoped=true"
import script from "./LoginPage.vue?vue&type=script&lang=ts"
export * from "./LoginPage.vue?vue&type=script&lang=ts"

import "./LoginPage.vue?vue&type=style&index=0&id=260194ca&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-260194ca"

export default script